export const fonts = {
    fontHeading: 'Poppins',
    fontContent: 'Poppins',
}; 